import i18n from 'i18next';
import { initReactI18next } from 'react-i18next'
import translationEn from './en/en';
import translationKR from './kr/kr';
import { GET_LANGUAGE_I18N } from '../../utils/UseFunc/UseStorage';

export const resources = {
  EN: {
    translation: translationEn
  },
  KR: {
    translation: translationKR
  }
};

i18n.use(initReactI18next).init({
  lng: GET_LANGUAGE_I18N(),
  // lng: 'EN',
  debug: false,
  defaultNs: 'translation',
  resources,
});

/*
언어 변경

i18next.init({
  lng : 'en'
})*/

export default i18n;